export const IconArrowNext = ({ color = '#FFFFFF' }) => {
  return (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.98836 0.292893L8.35232 6.65685C8.74284 7.04738 8.74284 7.68054 8.35232 8.07107L1.98836 14.435C1.59783 14.8256 0.964668 14.8256 0.574143 14.435C0.183619 14.0445 0.183619 13.4113 0.574143 13.0208L5.231 8.36396L6.14551 7.36396L5.231 6.36396L0.574143 1.70711C0.183619 1.31658 0.183619 0.683418 0.574143 0.292893C0.964668 -0.0976311 1.59783 -0.0976311 1.98836 0.292893Z"
        fill={color}
      />
    </svg>
  )
}

export default IconArrowNext
